import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FaIconComponent, FaLayersComponent} from '@fortawesome/angular-fontawesome';
import {faArrowsRotate, faCircle, faFolder} from '@fortawesome/pro-solid-svg-icons';

/**
 * Ordner, der aus einer externen Datenquelle synchronisiert wird (Figma `icon/folder-sync`): Ordner mit
 * kleinem Sync-Badge unten rechts. Font Awesome hat kein fertiges Ordner-Sync-Icon, daher als Layer.
 */
@Component({
  selector: 'app-folder-sync-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, FaLayersComponent],
  template: `
    <fa-layers [fixedWidth]="true" [class]="sizeClass" [attr.title]="title">
      <fa-icon [icon]="faFolder" [class]="folderClass"></fa-icon>
      <fa-icon [icon]="faCircle" transform="shrink-7 down-5 right-6" class="text-white"></fa-icon>
      <fa-icon [icon]="faCircle" transform="shrink-8 down-5 right-6" class="text-green"></fa-icon>
      <fa-icon [icon]="faArrowsRotate" transform="shrink-11 down-5 right-6" class="text-white"></fa-icon>
    </fa-layers>
  `
})
export class FolderSyncIconComponent {
  @Input() title = 'Mit SharePoint synchronisiert';
  @Input() sizeClass = 'text-base';
  @Input() folderClass = 'text-gray-400';

  protected readonly faFolder = faFolder;
  protected readonly faCircle = faCircle;
  protected readonly faArrowsRotate = faArrowsRotate;
}
